var map = {
	"./smallwhatwedo - German.html": "e56d",
	"./smallwhatwedo - Ireland old.html": "9053",
	"./smallwhatwedo - Ireland.html": "9e33",
	"./smallwhatwedo - United Kingdom.html": "9a11",
	"./whatisitabout.html": "65e4",
	"./whatwedo - Germany.html": "96d4",
	"./whatwedo - Ireland.html": "b87e",
	"./whatwedo - United Kingdom.html": "6af7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1441";